export enum PublishErrorFieldSource {
  LastModification = 'lastModification',
  CommitId = 'commitId'
}
